import axios from "axios";

const BASE_API = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

const getAuthHeaders = () => {
  const token = localStorage.getItem("tali_client_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getMyProfile = async () => {
  try {
    const response = await axios.get(`${BASE_API}/users/profile/me`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
